/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseSocialProfile } from '../../models/api-response-social-profile';
import { SocialAuthDto } from '../../models/social-auth-dto';

export interface VerifySocialSignUp$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: SocialAuthDto
}

export function verifySocialSignUp(http: HttpClient, rootUrl: string, params: VerifySocialSignUp$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseSocialProfile>> {
  const rb = new RequestBuilder(rootUrl, verifySocialSignUp.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseSocialProfile>;
    })
  );
}

verifySocialSignUp.PATH = '/v1/api/ui/public/sign-up/social/verify';
